import { CircularProgress, Link } from '@mui/material'
import { getConformityZipPreview } from 'controllers/conformity/index'
import { useState } from 'react'

interface ConformityZipPreviewLinkProps {
  disabled?: boolean
  vehicleGuid?: string
}

export default function ConformityZipPreviewLink({ disabled, vehicleGuid }: ConformityZipPreviewLinkProps) {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false)

  return (
    <Link
      onClick={() => {
        if (disabled || isSubmitting || !vehicleGuid) return

        setIsSubmitting(true)
        getConformityZipPreview(vehicleGuid).finally(() => setIsSubmitting(false))
      }}
      sx={{ cursor: disabled ? 'not-allowed' : isSubmitting ? 'wait' : 'pointer' }}
    >
      {isSubmitting ? <CircularProgress size={16} /> : 'Preview'}
    </Link>
  )
}
